import { Box, Stack, Typography } from "@mui/material";
import NoCustomerDataImage from "assets/images/lookingForData.svg";
import NoUserImage from "assets/images/noUserData.svg";
import { Button, PlusIcon } from "components";

function CustomerOnBoardingComponent({
  setIsOnboardingDrawerOpen,
  onBoarding,
}: {
  setIsOnboardingDrawerOpen: any;
  onBoarding: string;
}) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        marginBottom: "64px",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "radial-gradient(25.36% 25.77% at 50% 68.6%, #F4ECFF 0%, #FFFFFF 100%)",
        }}
        gap={"24px"}
      >
        {/* image component */}
        <img
          src={onBoarding === "customer" ? NoCustomerDataImage : NoUserImage}
          style={{ width: "20%", height: "auto" }}
        />
        {/* data  */}

        <Typography variant="h4">Let’s fill this space! </Typography>
        <Typography variant="body-large">
          Add your first {onBoarding === "customer" ? "customer" : "user"} to
          get started.
        </Typography>
        {/* add customer button  */}
        <Button
          className="intercom-addCustomer"
          variant="primary"
          endIcon={<PlusIcon />}
          onClick={() => setIsOnboardingDrawerOpen(true)}
        >
          {onBoarding === "customer" ? "Customer" : "User"}
        </Button>
      </Stack>
      <Stack
        direction={"row"}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "24px",
        }}
        gap={"8px"}
      >
        <Typography
          variant="body-large"
          color={"#767B85"}
          className="imageCardTitle"
        >
          Need help?
        </Typography>
        <Typography
          className="imageCardTitle"
          variant="body-large"
          sx={{
            color: "#5563F5",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            if (onBoarding === "customer") {
              window.open(
                "https://support.deskday.com/en/articles/8235972-adding-customer",
                "_blank",
              );
            } else {
              window.open(
                "https://support.deskday.com/en/articles/8235972-adding-customer",
                "_blank",
              );
            }
          }}
        >
          Learn how to add a new{" "}
          {onBoarding === "customer" ? "customer" : "user"}
        </Typography>
      </Stack>
    </Box>
  );
}

// export default CustomerOnBoardingComponent;
export { CustomerOnBoardingComponent };
